<template>
  <div class="main">
    <div class="menuContainer" :style="`width:${isHidden ? '0' : '221px'}`">
      <div class="hiddenIcon" @click="hiddenTab">
        <i :class="isHidden ? 'el-icon-caret-right' : 'el-icon-caret-left'" style="color: #fff" />
      </div>
      <el-menu :default-active="pathActive" text-color="#335483" active-text-color="#fff" :unique-opened="true" style="width: 221px" :style="`transform:translateX(${isHidden ? '-221px' : '0'});transition: all .3s;`" @select="selectMenu" router>
        <el-submenu index="/settle/consignment" v-has="'pc_settlement_consignor'">
          <template slot="title">
            <i class="el-icon-s-order" style="color: #335483" />
            <span>委托商结算管理</span>
          </template>
          <el-menu-item-group v-has="'pc_settlement_consignor_freight'">
            <el-menu-item index="/settle/consignment">托运费用结算</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_settlement_consignor_port'">
            <el-menu-item index="/settle/portCharges">港口费用结算</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_settlement_consignor_portAndWarehouse'">
            <el-menu-item index="/settle/clientPortWarehouseSettlement">库场及其他</el-menu-item>
          </el-menu-item-group>
          <!--          <el-menu-item-group v-has="'pc_settlement_consignor_unknown'">
                      <el-menu-item index="/settle/unknown">未知费用结算</el-menu-item>
                    </el-menu-item-group>-->
        </el-submenu>
        <!--        <el-submenu index="/settle/collection" >-->
        <!--          <template slot="title">-->
        <!--            <i class="el-icon-s-order" style="color:#335483"/>-->
        <!--            <span>结算管理</span>-->
        <!--          </template>-->
        <!--          <el-menu-item-group >-->
        <!--            <el-menu-item index="/settle/collection">收款结算</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group >-->
        <!--            <el-menu-item index="/settle/payment">付款结算</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group >-->
        <!--            <el-menu-item index="/settle/advance">收款预结算价结算</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--        </el-submenu>-->
        <!--        <el-submenu index="/settle/statement" >-->
        <!--          <template slot="title">-->
        <!--            <i class="el-icon-s-tools" style="color:#335483"/>-->
        <!--            <span>对账单管理</span>-->
        <!--          </template>-->
        <!--          <el-menu-item-group>-->
        <!--            <el-menu-item index="/settle/statement">收款对账单</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group>-->
        <!--            <el-menu-item index="/settle/paying">付款对账单</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--        </el-submenu>-->
        <el-submenu index="/audit/supplier" v-has="'pc_settlement_supplier'">
          <template slot="title">
            <i class="el-icon-s-tools" style="color: #335483" />
            <span>供应商结算管理</span>
          </template>
          <el-menu-item-group v-has="'pc_settlement_supplier_freight'">
            <el-menu-item index="/settle/supplier/consignSettle">托运费用结算</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_settlement_supplier_port'">
            <el-menu-item index="/settle/supplier/portSettle">港口费用结算</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_settlement_upplier_warehouse'">
            <el-menu-item index="/settle/supplier/storeroom">提车费结算</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_settlement_supplier_portAndWarehouse'">
            <el-menu-item index="/settle/supplierPortWarehouseSettlement">库场及其他结算</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="/settle/discount" v-has="'pc_settlement_other'">
          <template slot="title">
            <i class="el-icon-s-tools" style="color: #335483" />
            <span>其它结算管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/settle/discount" v-has="'pc_discount_invoicing'">抵扣开票费用</el-menu-item>
            <el-menu-item index="/settle/else" v-has="'pc_other_cost'">其它费用</el-menu-item>
            <el-menu-item index="/settle/recordAdjust" v-has="'pc_recon_adjust'">对账调整</el-menu-item>
            <el-menu-item index="/settle/oilPrice" v-has="'pc_price_expenses'">油价费用</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="/settle/shippingCharges" v-has="'pc_reckoning_consignor'">
          <template slot="title">
            <i class="el-icon-s-tools" style="color: #335483" />
            <span>委托商对账单</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/settle/shippingCharges" v-has="'pc_reckoning_consignor_freight'"> 托运费用对账单 </el-menu-item>
            <!--            <el-menu-item index='/settle/portCharges1' v-has="'pc_reckoning_consignor_port'">-->
            <!--              港口费用对账单-->
            <!--            </el-menu-item>-->
            <el-menu-item index="/settle/clientWarehouseStatement" v-has="'pc_reckoning_consignor_portAndWarehouse'"> 港口库房对账单 </el-menu-item>
            <el-menu-item index="/settle/clientElseStatements" v-has="'pc_other_expenses_portAndWarehouse'"> 其他费用对账单 </el-menu-item>
            <el-menu-item index="/settle/clientDeductionExpenses" v-has="'pc_deduction_expenses_portAndWarehouse'"> 抵扣费用对账单 </el-menu-item>
            <el-menu-item index="/settle/reconciliationAdjustmentStatement" v-has="'pc_reconciliation_adjustment_portAndWarehouse'"> 对账调整对账单 </el-menu-item>
            <!--            <el-menu-item index="/settle/unknown1" v-has="'pc_reckoning_consignor_unknown'">
                          未知费用对账单
                        </el-menu-item>-->
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="/settle/shippingFee">
          <template slot="title" v-has="'pc_reckoning_supplier'">
            <i class="el-icon-s-tools" style="color: #335483" />
            <span>供应商对账单</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/settle/shippingFee" v-has="'pc_reckoning_supplier_freight'"> 托运费对账单 </el-menu-item>
            <el-menu-item index="/settle/portFee" v-has="'pc_reckoning_supplier_port'">港口费对账单 </el-menu-item>
            <!--            <el-menu-item index='/settle/warehouseFee' v-has="'pc_reckoning_supplier_depository'">-->
            <!--              提车费对账单-->
            <!--            </el-menu-item>-->
            <el-menu-item index="/settle/supplierWarehouseStatement" v-has="'pc_reckoning_supplier_portAndWarehouse'"> 港口库房对账单 </el-menu-item>
            <el-menu-item index="/settle/supplierElseStatements" v-has="'pc_other_supplier_portAndWarehouse'"> 其他费用对账单 </el-menu-item>
            <el-menu-item index="/settle/supplierDeductionExpenses" v-has="'pc_deduction_supplier_portAndWarehouse'"> 抵扣费用对账单 </el-menu-item>
            <el-menu-item index="/settle/supplierReconciliationAdjustmentStatement" v-has="'pc_reconciliation_supplier_portAndWarehouse'"> 对账调整对账单 </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="/settle/otherBills" v-has="'pc_reckoning_other'">
          <template slot="title">
            <i class="el-icon-s-tools" style="color: #335483" />
            <span>其他对账单</span>
          </template>
          <el-menu-item-group>
            <!--            <el-menu-item index='/settle/exceedContract' v-has="'pc_reckoning_other_exceeding'">-->
            <!--              补结算管理-->
            <!--            </el-menu-item>-->
            <el-menu-item index="/settle/deferInvoicing" v-has="'pc_reckoning_other_suspend'"> 暂缓开票对账单 </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="/settle/accountDetails" v-has="'pc_settlement_account'">
          <template slot="title">
            <i class="el-icon-s-tools" style="color: #335483" />
            <span>台账管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/settle/accountDetails" v-has="'pc_settlement_account_detail'"> 结算台账(运输) </el-menu-item>
            <el-menu-item index="/settle/financeAccount" v-has="'pc_settlement_account_tz'"> 财务分析 </el-menu-item>
            <el-menu-item index="/settle/ledgerSummary" v-has="'pc_settlement_tz_collect'"> 结算台账汇总 </el-menu-item>
            <el-menu-item index="/settle/financeReconciliation" v-has="'pc_settlement_account_adjust'"> 财务调账 </el-menu-item>
            <!--            <el-menu-item index='/settle/reconciliationSummary'
                          v-has="'pc_settlement_adjust_collect'">
              调账汇总
            </el-menu-item>-->
            <el-menu-item index="/settle/portWarehouseLedger" v-has="'pc_settlement_account_portAndWarehouse'"> 结算台账(库房及其他) </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="/settle/supplierDelivery" v-has="'pc_receipt_manage'">
          <template slot="title">
            <i class="el-icon-s-tools" style="color: #335483" />
            <span>回单管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/settle/supplierDelivery" v-has="'pc_supplier_receipt_manage'"> 供应商交单管理 </el-menu-item>
            <el-menu-item index="/settle/settlementDelivery" v-has="'pc_settlement_receipt_manage'"> 结算部交单管理 </el-menu-item>
            <el-menu-item index="/settle/deliveryReport" v-has="'pc_receipt_manage_report'"> 交单报表 </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="/settle/settlementAnalysisStatement" v-has="'pc_statistics_lin'">
          <template slot="title">
            <i class="el-icon-s-tools" style="color: #335483" />
            <span>结算统计分析报表</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/settle/settlementAnalysisStatement/settlementProgress"  v-has="'pc_statistics_lin1'"> 结算进度统计表 </el-menu-item>
            <el-menu-item index="/settle/settlementAnalysisStatement/IncomeStatistics" v-has="'pc_statistics_lin2'"> 收入/支出台账与开票 </el-menu-item>
            <el-menu-item index="/settle/settlementAnalysisStatement/revenueSegmentation" v-has="'pc_statistics_lin3'"> 收入分段统计表 </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/settle/reconciliation/revenueSettlement' v-has="'pc_reconciliation_lin'">
          <template slot='title'>
            <i class='el-icon-s-tools' style='color:#335483' />
            <span>对账管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index='/settle/reconciliation/revenueSettlement' v-has="'pc_reconciliation_lin1'">根据收入结算</el-menu-item>
            <el-menu-item index='/settle/reconciliation/contractSettlement' v-has="'pc_reconciliation_lin2'">根据合同</el-menu-item>
            <el-menu-item index='/settle/reconciliation/tenderDocumentSettlement' v-has="'pc_reconciliation_lin3'">根据交单</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <div class="content2" :style="`width:${isHidden ? '100%' : 'calc(100% - 221px)'}`" style="background-color: rgb(244, 247, 251)">
      <router-view v-if="$route.path.split('/').length >= 3" style="background-color: rgb(244, 247, 251)" />
      <Home v-else />
      <div class="footer-div">渝ICP备2022002327号-1</div>
    </div>
  </div>
</template>

<script>
  import Home from '@/views/home/main';

  export default {
    components: {
      Home,
    },

    data() {
      return {
        pathActive: null,
        activeNum: 1,
        isHidden: false,
      };
    },
    watch: {
      $route(to, from) {
        this.pathActive = this.$route.path;
      },
    },
    mounted() {
      this.pathActive = this.$route.path;
    },
    methods: {
      hiddenTab() {
        this.isHidden = !this.isHidden;
      },
      selectMenu() {
        this.activeNum = 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;

    .menuContainer {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      position: relative;
      transition: all 0.3s;
      height: calc(100vh - 70px);
      overflow-x: hidden;

      .hiddenIcon {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #48599e;
        width: 11px;
        height: 50px;
        position: absolute;
        top: calc(50% - 20px);
        right: -11px;
        border-radius: 0 10px 10px 0;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .content {
      width: calc(100% - 221px);
      height: calc(100vh - 70px);
      overflow: auto;
    }

    .content2 {
      transition: all 0.3s;
      width: 100%;
      height: calc(100vh - 70px);
      overflow: auto;
    }

    ::v-deep {
      .el-menu-item.is-active {
        background-color: #335483;
      }

      .el-menu-item:focus {
        outline: 0;
        background-color: #335483;
      }
    }

    .content2 > .contract-list,
    .content2 > .electrify,
    .content2 > .operation,
    .content2 > .consignSettle,
    .content2 > .portSettle,
    .content2 > .stockpile,
    .content2 > .warehouse,
    .content2 > .deferlnvoicing,
    .content2 > .massLoss-list,
    .content2 > .logisticsConfig,
    .content2 > .finance-income,
    .content2 > .price-highway,
    .content2 > .main,
    .content2 > .supplierTrain,
    .content2 > .otherFees,
    .content2 > .mainContainer {
      height: calc(100% - 30px);
      overflow-y: auto;
    }

    .footer-div {
      display: block;
      position: relative;
      bottom: 0px;
      left: 0px;
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 13px;
      color: #a8a8a8;
      background-color: #f4f7fb;
    }
  }
</style>
